import { useRouter } from 'next/router'
import { FC } from 'react'

import { Box, Container } from '@material-ui/core'

import HeroSection from '~/components/shared/HeroSection'
import { Title } from '~/components/shared/Text'

import { getEntityByBrand } from '~/brands'

import useCreatePaypalOrder from './hooks/useCreatePaypalOrder'
import {
  CONGRATULATION_TITLE,
  ENTITIES
} from './utils/congratulation.constants'

import bgImageBoat from '~/../public/static/images/congratulation.boat.jpg'
import bgImageRv from '~/../public/static/images/congratulation.rv.jpg'

const bgImage = getEntityByBrand<string>({ rv: bgImageRv, boat: bgImageBoat })

const CongratulationView: FC = () => {
  const router = useRouter()
  const type = router?.query?.type as string

  useCreatePaypalOrder()

  const entity = ENTITIES[type] || ENTITIES.ad
  const congratulationTitle = CONGRATULATION_TITLE[entity]

  return (
    <Box position="relative">
      <HeroSection src={bgImage}>
        <Title m="auto" variant="h1" style={{ color: 'white' }}>
          Congratulations!
        </Title>
      </HeroSection>

      <Container maxWidth="md">
        <Title
          textAlign="center"
          variant="h2"
          fontSize={{ xs: 24, md: 30 }}
          mt={{ xs: 3.5, md: 6 }}
          mb={{ xs: 0, md: 30 }}
          whiteSpace="pre-line"
        >
          {congratulationTitle}
        </Title>
      </Container>
    </Box>
  )
}

export default CongratulationView
